module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./packages/lui-navigation/theme/lui-navigationdrawer.global.scss
// module id = 260
// module chunks = 0 1 9